// extracted by mini-css-extract-plugin
export default {"wrap":"GTue_8pXw8FkSKqsLKMQ","icon":"g5FgBjoYajo238u7Y8YL","copy":"lTKFqWwb_e1YKJcYV0k4","back":"fp8aLLk4mHn1kXhArJn_"};